import { AgreementEntity, AgreementAppContext } from "./agreement";
import { IsSearchField, IsSearchFieldProps } from "../../core/components/isSearchField";
import { FAIcon } from "../../core/components/faIcon";
import { ComponentHelper } from "../../core/util/componentHelper";
import { HTTPService } from "../../core/util/httpManager";
import { SheetEventType, Sheet } from "../../../siteManagement/sheet";
import { General } from "../../../siteManagement/general";
import { Helper } from "../../core/util/helper";
import { EventType } from "../../../siteManagement/eventManager";
import { StringKeyDictionary } from "../../commonInterfaces";
import {MultiSelect, MultiSelectProps} from "../../core/components/multiSelect";
import {DropDownList, DropDownListProps} from "../../core/components/dropDownList";
import React from "react";

export default class TimeZoneInfoBox extends React.Component<TimeZoneInfoBoxProps, TimeZoneInfoBoxState> {
    private _factory = ComponentHelper.createFactory();
    private _sheet: Sheet;
    private _translation: StringKeyDictionary<string>;
    constructor(props: TimeZoneInfoBoxProps) {
        super(props)
        this.state = {
            value: props.value,
            differentTimeZones: false,
            addressTimeZone: null
        };
        this._translation = props.context.translations;
        this._getAddressTimeZone(props.entity.PartnerAddressNumber);
        this._sheet = General.Sheet.Manager.getTopMostSheet();
        this._setEvents();
    }

    private _setEvents = () => {
        this._sheet.bind(SheetEventType.Custom, (cus: { command: string, adrNr: string }) => {
            if (cus.command === "SLAAgreementAdrNrChanged") {
                this._getAddressTimeZone(cus.adrNr);
            }
        });

        General.Events.bind(EventType.SavedSuccessfully, (data: {entity: {AdrNr: string},context: any}) => {
            if (data.context === "address") {
                this._getAddressTimeZone(data.entity.AdrNr);
            }
        });
    }

    private _updateEntity = (value: string) => {
        this.setState({
            value: value,
            differentTimeZones: (value !== this.state.addressTimeZone)
        }, () => {
            this.props.onChange(this.props.field, value, null, false);
        });
    }
    
    private _createDropDownList = () => {
        let props: DropDownListProps = this._factory.getDefaultDropDownProps();
        props.value = this.state.value;
        props.field.dataSourceUrl = "TimeZoneLookup/GetIanaTimeZonesDS";
        props.field.dataTextField = "Key";
        props.field.dataValueField = "Key";
        props.field.listWidth = 300;
        
        props.disabled = !this.props.entity.RecordRight.CanWrite;
        props.onChange = (field: any, value: any) => {
            this._updateEntity(value);
        }
        return (
            <div style={{ width: (this.state.differentTimeZones && Helper.hasValue(this.props.entity.PartnerAddressNumber) ? "90%" : "100%") }}>
                <DropDownList {...props} />
            </div>);
    }

    private _createInfoText = () => {
        const divStyle: React.CSSProperties = {
            fontSize: "11px",
            marginTop: "2px",
            width: "90%"
        }
        const text = this._translation["WebSMS.SLA.SetTimeZone"].replace("{timeZone}", this.state.addressTimeZone);
        return (
            <>
                <div style={divStyle}>
                    <a onClick={() => { this._updateEntity(this.state.addressTimeZone) }}>{text}</a>
                </div>
            </>
        );
    }


    private _createIcon = () => {
        const text: string = Helper.isNullOrEmpty(this.state.addressTimeZone) ? this._translation["WebSMS.SLA.NoTimeZone"] : this._translation["WebSMS.SLA.DifferentTimezones"].replace("{timezone}", this.state.addressTimeZone);
        return (<><FAIcon name="exclamation-circle" attributes={["lg"]} style={{ display: "flex", alignItems: "center", padding: "2px", color: "#f57c00" }} wrapperToolTip={text} /></>);
    }

    private _getAddressTimeZone = (adrNr: string) => {
        if(Helper.hasValue(adrNr))
            HTTPService.get<string>("TimeZoneLookup/GetTimezoneByAdrNr?adrNr=" + adrNr)
                .then(result => {
                    this.setState({ addressTimeZone: result, differentTimeZones: (this.state.value !== result)});
                });
    }

    render() {
        const dropDownList = this._createDropDownList();
        const icon = this.state.differentTimeZones && Helper.hasValue(this.props.entity.PartnerAddressNumber) ? this._createIcon() : null;
        const text = (this.state.differentTimeZones && !Helper.isNullOrEmpty(this.state.addressTimeZone) && this.props.entity.RecordRight.CanWrite) ? this._createInfoText() : null;
        return (
            <div>
                <div style={{ display: "flex" }}>
                    {dropDownList}
                    {icon}
                </div>
                {text}
            </div>
        );
    }
}

interface TimeZoneInfoBoxProps {
    entity: AgreementEntity
    context: AgreementAppContext;
    value: string;
    field: any;
    onChange: (field, value, dataItem, isInit) => void;
}

interface TimeZoneInfoBoxState {
    value: string;
    addressTimeZone: string;
    differentTimeZones: boolean;
}
